module.exports = __webpack_public_path__ + "img/img-2a9c50.jpg";